// needed?
import "unfetch/polyfill";
import "es6-promise/auto";

import * as cart from "@shopify/theme-cart";
import * as currency from "@shopify/theme-currency";

import { makeType, initLog } from "../ui/core/base";

import UI from "../ui/core/ui";

import { getWith, maybe, first } from "../ui/core/functions";

import { Stream } from "../ui/core/dispatcher-flyd";
import { modelChanged } from "../ui/components/common";

import Messages from "./messages";

const formatCurrency = (amount) =>
  currency.formatMoney(amount).replace("$", "");

const removeItem = (key) => {
  maybe((key) => {
    cart.removeItem(key).then((state) => {
      Messages({
        type: "state_update",
        state: state,
        // key: key
      });
    });
  })(key);
};

const updateQuantity = (key, quantity) => {
  maybe((key, quantity) => {
    if (quantity > 0) {
      cart
        .updateItem(key, {
          quantity: quantity,
        })
        .then((state) => {
          Messages({
            type: "state_update",
            state: state,
          });
        });
    } else {
      removeItem(key);
    }
  })(key, quantity);
};

const proto = {
  name: "Cart",
  initLog,

  init() {
    return {
      state: {},
      created: false,
    };
  },

  view(model) {
    console.log(`cart: view called:`, { ...model });
    if (model.created === true) {
      const state = model.state;
      const subtotal = first(this.dom.findByRole("subtotal"));
      console.log("subtotal", subtotal);
      maybe((subtotal) => {
        subtotal.textContent = formatCurrency(state.original_total_price);
      })(subtotal);

      if (state.items.length === 0) {
        location.reload(true);
      } else {
        const items = {};

        state.items.forEach((item) => (items[item.key] = item));

        this.dom.findByRole("line_item").forEach((line) => {
          const item = items[line.dataset.key];
          if (item == null) {
            line.remove();
          } else {
            const total = first(this.dom.findByRole(`item-total-${item.key}`));
            maybe((total) => {
              total.textContent = formatCurrency(item.line_price);
            })(total);
          }
        });
      }
    }

    return model;
  },

  update(msg, model) {
    console.log(`cart update: ${msg.type}`, msg);
    model = { ...model };

    switch (msg.type) {
      case "click": {
        if (msg.target.hasRole("remove_item")) {
          msg.preventDefault();

          removeItem(msg.target.dataset.key);
        }
        break;
      }
      case "change": {
        const target = msg.target;

        updateQuantity(
          target.dataset.key,
          parseInt(target.value)
          // this.eventStream.stream
        );

        break;
      }
      case "state_update": {
        model.state = msg.state;
        model.created = true;

        break;
      }
    }

    return model;
  },

  initialize(dom) {
    this.dom = dom;
    this.initLog();
    this.log.enable();
    this.log.warn(`cart: dom:`, this.dom)
    let currentModel = this.init();
    cart.getState().then((state) => {
      currentModel.state = state;
    });

    const listen = (msg) => {
      let model = { ...currentModel };
      model = this.update(msg, model);
      if (modelChanged(currentModel, model)) {
        model = this.view(model);
      }
      currentModel = model;
    };

    this.eventStream = new Stream();
    this.eventStream.map(listen);

    Messages.map(listen);

    this.view(currentModel);

    const glob = this;

    dom
      .findByRole("update_quantity")
      .forEach((t) => t.addEvent("change", glob.eventStream.stream));

    dom.findByRole("remove_item").forEach((t) => {
      t.addEvent("click", glob.eventStream.stream);
    });
  },
};

const Cart = makeType(proto);

UI.register("cart_form", Cart);
